import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-appointment-transaction',
  templateUrl: './appointment-transaction.component.html',
  styleUrls: ['./appointment-transaction.component.css']
})
export class AppointmentTransactionComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MAT_DIALOG_DATA) public appointment: any) {

    }


    ngOnInit() {
  }

}
